import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

import { MUIBreakpointLg } from '../../../../constants';

export const StyledMenuLabel = styled.div`
  color: ${token('colors.textDark')};
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: normal;
  padding: 12px;
  position: relative;
  z-index: 3;

  & {
    border-bottom: none;
  }

  @media screen and (min-width: ${MUIBreakpointLg}) {
    border: none;
    padding: 0;
  }

  .MenuLabel-text {
    align-self: center;
    flex: 1;
    line-height: 1.5;
    padding: 4px ${spaceMixin('md')} ${spaceMixin('xs')} 4px;
    text-align: left;

    @media screen and (min-width: ${MUIBreakpointLg}) {
      flex: 0;
      padding: 0;
    }
  }

  .MenuLabel-icon {
    border-left: solid 1px ${token('colors.gray300')};
    padding: ${spaceMixin('xs')} 12px 4px ${spaceMixin('md')};
    margin-top: ${spaceMixin('xs')};

    svg {
      color: ${token('colors.brand')};
    }

    @media screen and (min-width: ${MUIBreakpointLg}) {
      border: none;
      padding: ${spaceMixin('xs')};
    }
  }

  .MenuLabel.MenuLabel-open {
    color: ${token('colors.blue400')};
    font-weight: 600;
  }
`;
